import { useRiskIntelContext } from './RiskIntelProvider';

export const useRiskIntel = () => useRiskIntelContext();
